import React from 'react';
import PropTypes from 'prop-types';
import { CardItem } from '../../../Card/CardItem';
import { contentPackageSmallStyle } from '../style/contentPackageSmallStyle';
import { getContentPackageStackCardDatum } from './utils/contentPackageUtils';
import { GridColumn, GridRow } from '../../../responsive/atoms/Grid';
import { ContentPackageHeaderSection } from '../ContentPackageHeaderSection';
import { Container } from '../../../responsive/atoms/Container';
import { Ad } from '../../../responsive/atoms/Ad';

const imageMaxWidths = {
  mobile: 727,
  tablet: 309,
  small_desktop: 373,
  large_desktop: 459
};

export const ContentPackageTemplate2b = ({ data, content, isAboveTheFold }) => {
  const stackCardDatum = getContentPackageStackCardDatum(data);
  const stylesSmall = contentPackageSmallStyle(data.backgroundColor);

  const hasHeaderSection = !!(data.contentPackageHeader || data.description);

  return (
    <Container margin="0 auto" backgroundColor={data.backgroundColor}>
      <Container
        maxWidth="100rem"
        padding={
          hasHeaderSection
            ? [
                '0 20px 40px 20px',
                '0 24px 40px 24px',
                '0 40px 40px 40px',
                '0 56px 40px 56px'
              ]
            : ['20px', '24px', '40px', '56px']
        }
      >
        {hasHeaderSection && (
          <ContentPackageHeaderSection
            title={data.contentPackageHeader}
            description={data.description}
          />
        )}

        <GridRow gutter={['20px', '12px', '20px', '28px']}>
          <GridColumn width={[12, 6, 4]}>
            {stackCardDatum[0] && (
              <CardItem
                styles={stylesSmall}
                data={stackCardDatum[0]}
                aspect="16x9"
                isAboveTheFold={isAboveTheFold}
                imageMaxWidths={imageMaxWidths}
              />
            )}
          </GridColumn>

          <GridColumn width={[12, 6, 4]}>
            {stackCardDatum[1] && (
              <CardItem
                styles={stylesSmall}
                data={stackCardDatum[1]}
                aspect="16x9"
                isAboveTheFold={isAboveTheFold}
                imageMaxWidths={imageMaxWidths}
                canBeAnimated
              />
            )}
          </GridColumn>

          <GridColumn width={[12, 12, 4]}>
            <Ad
              key={`content_package_right_with_tablet_full_width__${data.id}`}
              id={`content_package_right_with_tablet_full_width__${data.id}`}
              content={content}
            />
          </GridColumn>
        </GridRow>
      </Container>
    </Container>
  );
};

ContentPackageTemplate2b.defaultProps = {
  isAboveTheFold: false
};

ContentPackageTemplate2b.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
